import React from "react"
import { Alert } from "react-bootstrap"

export default function CloseableProcessesStatus({ error, running, runningText, success,
successText, close, handleClose }) {

  if(close) return null
  return error
  ? <Alert bsStyle="danger" onDismiss={ handleClose }>
      <strong>{ error }</strong>
    </Alert>
  : running
  ? <Alert bsStyle="info" onDismiss={ handleClose }>
      <strong>{ runningText ? runningText : 'Running, please wait..' }</strong>
    </Alert>
  : success
  ? <Alert bsStyle="success" onDismiss={ handleClose }>
      <strong>{ successText ? successText : 'Completed successfully' }</strong>
    </Alert>
  : null
}



// WEBPACK FOOTER //
// ./src/components/fragments/CloseableProcessesStatus.js